import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { Delta } from 'jsondiffpatch/lib/types';
import { CHAIRMAN_EXTENSION_GUEST_CONFIGURATION_KEYS_CONFIG } from '@ag-common-lib/lib/lists/change-logs/registrant-change-logs-config.list';
import { LookupDescriptionTextPipe } from 'ag-common-svc/shared/pipes/lookup-description-text.pipe';

@Component({
  selector: 'ag-shr-change-log-guest-configuration',
  templateUrl: './change-log-guest-configuration.component.html',
  styleUrls: ['./change-log-guest-configuration.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LookupDescriptionTextPipe],
})
export class ChangeLogGuestConfigurationComponent {
  @Input()
  set log(delta: Delta) {
    this._log = delta;
    const guestConfigurationLog = Array.isArray(delta) ? delta : [delta];
    if (guestConfigurationLog.length === 1) {
      const guestConfigurationFrom = this.lookupDescriptionText.transform(
        guestConfigurationLog[0] as string,
        this.guestConfigurationLookup,
      );
      this.guestConfigurationMessage = `Guest Configuration added as <span class="ag-change-log-detail--new-value">${guestConfigurationFrom}<span>`;
    }
    if (guestConfigurationLog.length === 2) {
      const guestConfigurationFrom = this.lookupDescriptionText.transform(
        guestConfigurationLog[0] as string,
        this.guestConfigurationLookup,
      );
      const guestConfigurationTo = this.lookupDescriptionText.transform(
        guestConfigurationLog[1] as string,
        this.guestConfigurationLookup,
      );
      this.guestConfigurationMessage = `Guest Configuration changed from <span class="ag-change-log-detail--old-value">${guestConfigurationFrom}</span> to <span class="ag-change-log-detail--new-value">${guestConfigurationTo}</span>`;
    }
  }

  get log(): Delta {
    return this._log;
  }

  private lookupDescriptionText = inject(LookupDescriptionTextPipe);
  private _log: Delta;
  guestConfigurationMessage: string;
  protected readonly guestConfigurationLookup = CHAIRMAN_EXTENSION_GUEST_CONFIGURATION_KEYS_CONFIG;
}
